import {
  parseMessageTemplate,
  renderTemplate,
  renderTemplateWithPlaceholders,
} from "@/lib/message-template"

/** Matches Automation::VARIABLE_PATTERN on the server. */
export const VARIABLE_PATTERN = /\{([a-z0-9_]+)\}/gi

/**
 * The browser-side mirror of Automations::MessageRenderer, so the setup
 * screen's preview updates as you type without asking the roster again. The
 * server renders what actually gets sent; these two are kept in step by their
 * tests.
 *
 * A token the sample member does not carry comes out empty, exactly as it will
 * on a real send — nobody should ever receive the literal text "{first_name}".
 * Conditions are decided through lib/message-template.ts. An invalid message
 * throws, as it does on the server; check it with parseMessageTemplate first.
 */
export function renderMessage(
  message: string,
  values: Record<string, string>,
): string {
  return renderTemplate(parseMessageTemplate(message), values)
}

/**
 * What the preview shows when nothing matches: the token names themselves,
 * bracketed so they are never mistaken for a real member's details.
 */
export function renderMessageWithPlaceholders(message: string): string {
  return renderTemplateWithPlaceholders(parseMessageTemplate(message))
}

/**
 * The variable names a message references, in the order they first appear.
 *
 * A condition's tested field counts: the pattern finds {employer} inside
 * <if{employer}, and never matches the word "if".
 */
export function messageVariables(message: string): string[] {
  return [...new Set([...message.matchAll(VARIABLE_PATTERN)].map((m) => m[1]))]
}
